import React from 'react';

interface CancelConfirmDialogProps {
    message: string;
    subtext?: string;
    yesLabel?: string;
    noLabel?: string;
    yesUrlPath?: string;
    onNo: () => void;
    onYes?: () => void;
}

const CancelConfirmDialog: React.FC<CancelConfirmDialogProps> = ({
    message,
    subtext,
    yesLabel = 'Yes',
    noLabel = 'No',
    yesUrlPath,
    onNo,
    onYes,
}) => {
    const handleYes = () => {
        if (onYes) {
            onYes();
        } else if (yesUrlPath) {
            window.location.href = yesUrlPath;
        } else {
            onNo();
        }
    };

    return (
        <div className="cancel-confirm-overlay">
            <div className="cancel-confirm-dialog" role="dialog" aria-modal="true">
                <div className="cancel-confirm-dialog__header">
                    <h3 className="cancel-confirm-dialog__title">{message}</h3>
                    <button
                        type="button"
                        className="cancel-confirm-dialog__close"
                        onClick={onNo}
                        aria-label="Close"
                    >
                        &times;
                    </button>
                </div>
                {subtext && <p className="cancel-confirm-dialog__subtext">{subtext}</p>}
                <hr className="cancel-confirm-dialog__divider" />
                <div className="cancel-confirm-dialog__actions">
                    <button
                        type="button"
                        className="btn btn-add"
                        onClick={handleYes}
                    >
                        {yesLabel}
                    </button>
                    <button
                        type="button"
                        className="btn btn-cancel"
                        onClick={onNo}
                    >
                        {noLabel}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default CancelConfirmDialog;
